// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__1DlI3","materialTitle":"Section_materialTitle__1iDK8","title":"Section_title__-AAT2","count":"Section_count__3bNw4"};